import React from 'react';
import ContactForm from './components/Contact/ContactForm';
import ValueProp from './components/ValueProp';
import Landing from './components/Landing';
import Impressum from './components/Impressum';
import impressumData from './components/impressumData';

function App() {
  return (
    <div className="App">
      <Landing />
      <ValueProp />
      <ContactForm />
      <Impressum {...impressumData} />
    </div>
  );
}

export default App;
